"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const coam_sapidus_1 = require("@cimpress-technology/coam-sapidus");
var Actions;
(function (Actions) {
    Actions["post"] = "POST";
    Actions["put"] = "PUT";
    Actions["patch"] = "PATCH";
    Actions["delete"] = "DELETE";
    Actions["workingDaysUpdate"] = "WORKING-DAYS-UPDATE";
})(Actions = exports.Actions || (exports.Actions = {}));
var AuditOnlyResourceTypes;
(function (AuditOnlyResourceTypes) {
    AuditOnlyResourceTypes["LogisticsLocationPermissions"] = "logistics-location-permissions";
    AuditOnlyResourceTypes["LogisticsNetworkPermissions"] = "logistics-network-permissions";
})(AuditOnlyResourceTypes || (AuditOnlyResourceTypes = {}));
exports.AuditResources = Object.assign(Object.assign({}, coam_sapidus_1.models.ResourceTypes), AuditOnlyResourceTypes);
//# sourceMappingURL=index.js.map